import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import SurOrderHistoryState from "@tSurya/Store/Data/SurOrderHistoryState";
import { Draft } from "immer";

const initialState: SurOrderHistoryState = {
    surfiltersOpen: false,
};

const reducer = {
    "Pages/SurOrderHistory/SurToggleFiltersOpen": (draft: Draft<SurOrderHistoryState>) => {
        draft.surfiltersOpen = !draft.surfiltersOpen;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
